import { MutationTree } from "vuex";
import { EvalSourceMapDevToolPlugin } from "webpack";
import { AuthState, Usuario } from "./types";

type AuthMutationTree = MutationTree<AuthState>;

export const mutations: AuthMutationTree = {
  setUsuario(state: AuthState, usuario: Usuario) {
    state.usuario = usuario;
    state.isLogged = true;
  },
  setResetPassword(state: AuthState) {
    if(state.usuario!=null) state.usuario.resetPassword = false;
  },
  unsetUsuario(state: AuthState) {
    state.usuario = null;
    state.isLogged = false;
  },
};
